import React, { useEffect } from "react";
import Navbar from "../Header&Footer/Navbar";
import Footer from "../Header&Footer/Footers";
import "./AMCComponent.css";

export default function AMCComponent() {
  // 👇 Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const plans = [
    {
      id: "washing",
      name: "Washing Machine AMC",
      price: 899,
      duration: "1 Year",
      serviceCount: 3,
      highlights: [
        "🔧 Unlimited Free Repair Service — peace of mind all year!",
        "💰 Up to 50% Discount during AMC period!",
        "🧾 40 General Check-ups in every service visit!",
      ],
    },
    {
      id: "ac",
      name: "AC AMC",
      price: 1999,
      duration: "1 Year",
      serviceCount: 3,
      highlights: [
        "🔧 Unlimited Free Repair Service — peace of mind all year!",
        "💰 Up to 50% Discount during AMC period!",
        "🧾 30 General Check-ups in every service visit!",
      ],
    },
    {
      id: "fridge",
      name: "Fridge AMC",
      price: 699,
      duration: "1 Year",
      serviceCount: 3,
      highlights: [
        "🔧 Unlimited Free Repair Service — peace of mind all year!",
        "💰 Up to 50% Discount during AMC period!",
        "🧾 20 General Check-ups in every service visit!",
      ],
    },
    {
      id: "water",
      name: "Water Purifier AMC",
      price: 1099,
      duration: "1 Year",
      serviceCount: 4,
      highlights: [
        "🔧 Unlimited Free Repair Service — peace of mind all year!",
        "💰 Up to 50% Discount during AMC period!",
        "🧾 10 General Check-ups in every service visit!",
      ],
    },
  ];

  return (
    <>
      <Navbar />
      <div className="amc-container">
        <h2 className="amc-title">🎉 SERV E2E – Annual Maintenance Contract (AMC)</h2>
        <p className="amc-intro">
          Keep your home appliances running smoothly all year! Our AMC plans
          include free repairs, periodic check-ups, and great discounts on spares.
        </p>

        <div className="amc-grid">
          {plans.map((plan) => (
            <div key={plan.id} className="amc-card">
              <h3 className="amc-plan-title">{plan.name}</h3>
              <p className="amc-price">
                ₹{plan.price} / {plan.duration}
              </p>
              <p className="amc-service-text">
                Includes {plan.serviceCount} services per year.
              </p>

              <h4 className="amc-highlight-title">✨ Highlights ✨</h4>
              <ul className="amc-list">
                {plan.highlights.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>

              {/* <button className="amc-btn">Subscribe Now</button> */}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
